var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sjfb"},[_c('vab-chart',{attrs:{"option":_vm.options,"autoresize":"","theme":"vab-echarts-theme"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }